import { Box, Container, Typography, Grid, Card, CardContent, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Download, Apple, Android, PictureAsPdf, Article, School } from '@mui/icons-material';

const Resources = () => {
  const resources = [
    { title: 'Investment Guide 2024', type: 'PDF', icon: <PictureAsPdf />, size: '2.4 MB' },
    { title: 'ESG Annual Report', type: 'PDF', icon: <PictureAsPdf />, size: '3.1 MB' },
    { title: 'Refining Specifications', type: 'PDF', icon: <PictureAsPdf />, size: '1.8 MB' },
    { title: 'Market Outlook Q1 2025', type: 'PDF', icon: <PictureAsPdf />, size: '1.2 MB' },
  ];

  return (
    <Box>
      <Box sx={{ height: '40vh', background: 'linear-gradient(135deg, #0A0A0A 0%, #1A1A1A 100%)', display: 'flex', alignItems: 'center' }}>
        <Container maxWidth="lg">
          <Typography variant="h1" gutterBottom>Resources</Typography>
          <Typography variant="h5" color="text.secondary">Market insights and tools</Typography>
        </Container>
      </Box>

      <Container maxWidth="xl" sx={{ py: 8 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h3" gutterBottom>Kitco Mobile App</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Get real-time prices, charts, and news on your mobile device
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
              <Button variant="contained" startIcon={<Apple />}>App Store</Button>
              <Button variant="outlined" startIcon={<Android />}>Google Play</Button>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Typography variant="h3" gutterBottom>Download Library</Typography>
            <Grid container spacing={2}>
              {resources.map((item) => (
                <Grid item xs={12} key={item.title}>
                  <Card>
                    <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        {item.icon}
                        <Box>
                          <Typography variant="body1">{item.title}</Typography>
                          <Typography variant="caption" color="text.secondary">{item.size}</Typography>
                        </Box>
                      </Box>
                      <Button size="small" startIcon={<Download />}>Download</Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Resources;